export enum LineType {
	// FUNCTION_DECLARATION = 'function_declaration',
	MEMBER = 'member',
	CONSTRUCTOR = 'constructor',
	DEFINE = 'define',
	BODY = 'body',
	// TRIGGER = 'trigger',
	// TRIGGERABLE = 'triggerable',
}
